module.exports = __webpack_public_path__ + "img/resized-APP-0023-1.03eb855e.png";